// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__10n56","upload":"Small_upload__ch0DD","imageWrap":"Small_imageWrap__2IN8X","removeBtn":"Small_removeBtn__I9aCn"};